import { useCallback, useEffect, useState } from 'react';
import { useDebounce } from 'hooks';
import { Location } from 'types';

export function useSuburbList(locations: Location[]) {
  const [filteredItems, setFilteredItems] = useState<Location[]>([]);
  const [searchInput, setSearchInput] = useState('');
  const debouncedValue = useDebounce<string>(searchInput, 500);

  const clearSearch = useCallback(() => {
    setSearchInput('');
    setFilteredItems([]);
  }, []);

  useEffect(() => {
    if (debouncedValue) {
      const filtered = locations.filter((item) => {
        const nameMatch = item.location
          .toLowerCase()
          .includes(debouncedValue.toLowerCase());
        const postcodeMatch = item.postcode
          ?.toString()
          .includes(debouncedValue);
        return nameMatch || postcodeMatch;
      });

      setFilteredItems(filtered);
    }
  }, [debouncedValue, locations]);

  const handleInputChange = (inputValue: string) => {
    setSearchInput(inputValue);
  };

  return {
    searchInput,
    filteredItems,
    handleInputChange,
    clearSearch
  };
}
